import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FORM_CONTROL_WIDTH } from './constants'

const ProfileFormGroup = ({ className, ...rest }) => (
  <div
    className={classnames('relative mb-5 w-full md:mb-10', FORM_CONTROL_WIDTH, className)}
    {...rest}
  />
)

ProfileFormGroup.propTypes = {
  className: PropTypes.string,
}

export default ProfileFormGroup
